// extracted by mini-css-extract-plugin
module.exports = {"wizardPagesContainer":"wizard-step-indicator_wizardPagesContainer__29iiz","actual":"wizard-step-indicator_actual__1Xr__","other":"wizard-step-indicator_other__2NtRg"};